import React, { useState, useEffect } from "react";
import { Form, Col, Row } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import KTImageInput from "../../../../../_metronic/_assets/js/components/image-input";

export function SchoolInfoForm({ 
  schoolProfile,
  handleChange,
  setFieldValue,
  values
 }) {
  const [logo, setLogo] = useState("");
  const formationYear = values.formationYear != null ? values.formationYear : "";

  useEffect(() => {
    schoolProfile.logoStr ? setLogo(schoolProfile.logoStr) : setLogo("");
  }, [schoolProfile]);

  const getSchoolLogo = () => {
    if (!logo) {
      return "none";
    }

    return `url(${logo})`;
  };

  const removeLogo = () => {
    setLogo("");
  };

  new KTImageInput("school_logo");

  return (
    <>
      <div className="row">
        <div className="col-6">
          <Form.Group as={Row} controlId="logo">
            <Form.Label column sm={3}>
              Okul Logosu
            </Form.Label>
            <Col sm={9}>
              <div
                className="image-input image-input-outline"
                id="school_logo"
                style={{
                  backgroundImage: `url(${toAbsoluteUrl(
                    "/media/users/blank.png"
                  )}`,
                }}
              >
                <div
                  className="image-input-wrapper"
                  style={{ backgroundImage: `${getSchoolLogo()}`}}
                />
                <label
                  className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                  data-action="change"
                  data-toggle="tooltip"
                  title=""
                  data-original-title="Change logo"
                >
                  <i className="fa fa-pen icon-sm text-muted"></i>
                  <input
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    onChange={e => setFieldValue("logoFile", e.target.files[0])}
                  />
                  <input type="hidden" name="school_logo_remove" />
                </label>
                <span
                  onClick={e => setFieldValue("logoFile", null)}
                  className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                  data-action="cancel"
                  data-toggle="tooltip"
                  title=""
                  data-original-title="Cancel logo"
                >
                  <i className="ki ki-bold-close icon-xs text-muted"></i>
                </span>
                <span
                  onClick={removeLogo}
                  className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                  data-action="remove"
                  data-toggle="tooltip"
                  title=""
                  data-original-title="Remove logo"
                >
                  <i className="ki ki-bold-close icon-xs text-muted"></i>
                </span>
              </div>
              <span className="form-text text-muted">
                İzin Verilen Dosya Türleri: png, jpg, jpeg.
              </span>
            </Col>
          </Form.Group>
        </div>
      </div>

      <div className="row">
        <div className="col-6">                 
          <Form.Group as={Row} controlId="name">
            <Form.Label column sm={3}>
              Okul Adı <span>*</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.name} placeholder="Okul Adı" onChange={handleChange} />
            </Col>
          </Form.Group>
                    
          <Form.Group as={Row} controlId="companyName">
            <Form.Label column sm={3}>
              Şirket Adı
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.companyName} placeholder="Şirket Adı" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="formationYear">
            <Form.Label column sm={3}>
              Okul Kuruluş Yılı
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="number" min={0} value={formationYear} placeholder="Okul Kuruluş Yılı" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="mebsisNo">
            <Form.Label column sm={3}>
              Okul Mebsis No
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.mebsisNo} placeholder="Okul Mebsis No" onChange={handleChange} />
            </Col>
          </Form.Group>
        </div>

        <div className="col-6">
          <Form.Group as={Row} controlId="address">
            <Form.Label column sm={3}>
              Okul Adresi
            </Form.Label>
            <Col sm={9}>
              <Form.Control as="textarea" rows="2" value={values.address} placeholder="Okul Adresi" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="invoiceAddress">
            <Form.Label column sm={3}>
              Tahsilat Makbuzu Ve Fatura Adresi
            </Form.Label>
            <Col sm={9}>              
              <Form.Control as="textarea" rows="2" value={values.invoiceAddress} placeholder="Tahsilat Makbuzu Ve Fatura Adresi" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="city">
            <Form.Label column sm={3}>
              İl
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.city} placeholder="İl" onChange={handleChange} />
            </Col>
          </Form.Group>
        </div>
      </div>
    </>
  );
}